"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M22.521 31.8a11.308 11.308 0 0 1-11.053-9.023l-.031-.16h-9.7a.256.256 0 0 1-.225-.131.249.249 0 0 1 0-.256l10.224-17.9a.26.26 0 0 1 .449 0l3.941 6.9.18-.119A11.279 11.279 0 1 1 22.521 31.8zm-9.086-8.934a9.381 9.381 0 1 0 3.789-10.09l-.152.1 5.342 9.35a.249.249 0 0 1 0 .256.256.256 0 0 1-.225.131h-8.818z" })
);

